import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotificationsModel } from '../models/Notification';
import { environment } from 'public/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(private http: HttpClient) { }

  GetUnseenNotificationCount() {
    return this.http.get(`${environment.apiUrl}/Notification/GetUnseenNotificationCount`);
  }
  GetNotifications(params: any) {
    return this.http.get(`${environment.apiUrl}/Notification/List`, { params });
  }
  UpdateNotificationsSeenStatus() {
    return this.http.get(`${environment.apiUrl}/Notification/UpdateNotificationsSeenStatus`);
  }
  SeeNotifications(id: any) {
    return this.http.get(`${environment.apiUrl}/Notification/SeeNotifications?NotificationID=${id}`);
  }
}
